<template>
  <div>
    <ShopCart v-if="filterStore.store" :store="filterStore.store" />
    <div class="content-product-intern">
      <div class="content-product-intern-itens container">
        <div class="content-brand">
          <GoToBackButton />
          <div class="content-brand-elements d-none d-lg-block">
            <router-link tag="a" :to="{ name: 'Home' }" class="content-brand-elements-links">
              {{ $t('pages.goToBackButton.start') }}
            </router-link>
            <span> > </span>
            <router-link tag="a" :to="{ name: 'HomeStore' }" class="content-brand-elements-links">
              {{ productDetails.store ? productDetails.store.name : '' }}
            </router-link>
            <span> > </span>
            <router-link tag="a" :to="{
              name: 'CategoriesStore',
              params:
              {
                family: productDetails?.family?.slug
              },
            }" class="content-brand-elements-links">
              {{ productDetails?.family?.name }}
            </router-link>
            <span> > </span>
            <a class="content-brand-elements-links"
              @click="sendFilter(productDetails?.subfamily?.slug, productDetails?.family?.slug)">{{
                productDetails?.subfamily?.name
              }}
            </a>
            <span> > </span>
            <a class="content-brand-elements-links">
              {{ productDetails?.name }}
            </a>
          </div>
          <SocialSharing class="d-lg-none" :title="title" :description="short_description" />
        </div>
        <div class="content-product-intern-itens-header">
          <h1 class="title">{{ $t('pages.product.title') }}<span
              v-if="productDetails.family && productDetails.family.name">
              {{ productDetails.family.name }}</span>
          </h1>
          <div class="content-product-intern-itens-header-sociais d-none d-lg-flex">
            <BtnFavorite :name="title" />
            <SocialSharing :title="title" :description="short_description" />
          </div>
        </div>
        <div class="content-product">
          <div class="row">
            <div class="col-lg-6">
              <div class="content-product-gallery">
                <!-- swiper1 -->
                <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                  <swiper-slide v-for="(photoItem, k) in productDetails.photos" :key="k">
                    <div class="gallery-top-image" :style="{ background: `url(${photoItem})` }">
                      <div class="gallery-top-image-discount" v-if="productDetails.discount_percent">{{
                        productDetails.discount_percent }}</div>
                    </div>
                  </swiper-slide>
                </swiper>
                <!-- swiper2 thumbs -->
                <swiper class="swiper gallery-thumbs gallery-thumbs-product-intern" :options="swiperOptionThumbs"
                  ref="swiperThumbs">
                  <swiper-slide v-for="(photoItem, g) in productDetails.photos" :key="g">
                    <div class="gallery-thumbs-image" :style="{ background: `url(${photoItem})` }"></div>
                  </swiper-slide>
                  <div class="swiper-button-prev d-none d-lg-flex" slot="button-prev">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.842" height="17.131" viewBox="0 0 22.842 17.131">
                      <path d="M11.421,17.131,0,0H22.842Z" fill="#fff" fill-rule="evenodd" />
                    </svg>
                  </div>
                  <div class="swiper-button-next d-none d-lg-flex" slot="button-next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.842" height="17.131" viewBox="0 0 22.842 17.131">
                      <path d="M11.421,17.131,0,0H22.842Z" fill="#fff" fill-rule="evenodd" />
                    </svg>
                  </div>
                </swiper>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="content-product-details">
                <div class="content-product-details-help d-lg-none">
                  <BtnFavorite :name="title" />
                  <button class="btn-help" @click="$bvModal.show('modal-help')">
                    {{ $t('pages.product.faq') }}
                  </button>
                </div>
                <div class="content-product-details-type" v-if="productDetails.subfamily.name">
                  <h3>{{ productDetails.subfamily.name }}</h3>
                </div>
                <div class="content-product-details-name" v-if="productDetails.name">
                  <h2>{{ productDetails.name }}</h2>
                </div>
                <div class="content-product-details-price">
                  <template v-if="productDetails.iva_promotional_price > 0">
                    <div class="price-discount">
                      <p>{{ productDetails.iva_price | money }}</p>
                    </div>
                    <div class="price-current">
                      <p>{{ productDetails.iva_promotional_price | money }}</p>
                    </div>
                  </template>
                  <template v-else>
                    <div class="price-current">
                      <p>{{ productDetails.iva_price | money }}</p>
                    </div>
                  </template>
                </div>
                <div class="content-product-details-help d-none d-lg-flex">
                  <button class="btn-help" @click="$bvModal.show('modal-help')">
                    Dúvidas
                  </button>
                </div>
                <div class="content-product-details-btns">
                  <div class="number">
                    <button class="minus" @click="btnMinus()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="22.698" height="5.536" viewBox="0 0 22.698 5.536">
                        <path d="M1.584-9.312v5.536h22.7V-9.312Z" transform="translate(-1.584 9.312)"
                          fill="var( --green-medium)" />
                      </svg>
                    </button>
                    <input type="text" v-model="productQuantity" />
                    <button class="plus" @click="btnPlus()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="19.704" height="19.704" viewBox="0 0 19.704 19.704">
                        <path d="M8.768-12.912v7.594H1.224V-.8H8.768V6.792h4.566V-.8h7.594V-5.318H13.335v-7.594Z"
                          transform="translate(-1.224 12.912)" fill="var( --green-medium)" />
                      </svg>
                    </button>
                  </div>
                  <button class="btn-add-product" @click="addProduct()">
                    <p>{{ $t('pages.product.add') }}</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18.492" height="16.437" viewBox="0 0 18.492 16.437">
                      <path
                        d="M17.721,2.055H4.15L3.883.629A.771.771,0,0,0,3.126,0H.385A.385.385,0,0,0,0,.385V.642a.385.385,0,0,0,.385.385H2.912L5.157,13a2.055,2.055,0,1,0,3.3.355h4.66a2.055,2.055,0,1,0,3.211-.445.771.771,0,0,0-.748-.582h-9.5l-.385-2.055H16.33a.771.771,0,0,0,.754-.613l1.391-6.678A.771.771,0,0,0,17.721,2.055ZM7.705,14.383a1.027,1.027,0,1,1-1.027-1.027A1.028,1.028,0,0,1,7.705,14.383ZM14.9,15.41a1.027,1.027,0,1,1,1.027-1.027A1.028,1.028,0,0,1,14.9,15.41Zm1.225-6.164H5.5L4.343,3.082H17.405Z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-product-description">
          <div class="row">
            <div class="col-lg-8">
              <div class="content-product-description-header">
                <h2>{{ $t('pages.product.productdescription') }}</h2>
              </div>
              <div class="content-product-description-text">
                <p v-html="productDetails.description"></p>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="content-ads">
                <div v-if="!publicities.image_halfpage">
                  <img class="img-fluid" src="@/assets/img/product-intern/image-ads.png" alt="image ads"
                    title="image ads" />
                </div>
                <a v-else :href="publicities.image_halfpage_url" target="_blank" rel="noopener">
                  <img class="img-fluid" :src="publicities.image_halfpage.path" alt="image ads" title="image ads" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="content-product-features">
          <div class="row">
            <div class="col-12">
              <div class="content-product-features-header">
                <h2>{{ $t('pages.product.features') }}</h2>
              </div>
              <div class="content-product-features-text">
                <p v-html="productDetails.description_tech"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="content-product-sugestions" v-if="Object.keys(highLightProducts).length">
          <div class="content-product-sugestions-header">
            <h2>{{ productDetails.family.name }}<span>{{ productDetails.subfamily.name }}</span></h2>
          </div>
          <div class="content-product-sugestions-body">
            <swiper :options="swiperProducts">
              <swiper-slide v-for="(n, nKey) in highLightProducts" :key="nKey">
                <CardProduct :product="n" />
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <CategoryStore :categories="categories" :slug="this.slug" />
      <MenuCart />
      <section class="partner-content container">
        <div class="togoback bottom">
          <div class="content-brand w-100 mb-0">
            <GoToBackButton />
          </div>
        </div>
      </section>
      <ModalHelp />
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapGetters } from "vuex";
import CardProduct from '@/components/cards/CardProduct.vue';
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";
import SocialSharing from "@/components/socialSharing/SocialSharing";
import BtnFavorite from "@/components/btnFavorite/Index";
import ModalHelp from "@/components/modals/ModalHelp.vue";
import CategoryStore from "../components/CategoryStore.vue";
import MenuCart from "../components/MenuCart.vue";
import ShopCart from '../components/ShopCart.vue';
import axios from 'axios';

export default {
  data() {
    return {
      access_token: '',
      short_description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eu interdum ex. Sed ornare bibendum ante non viverra. Nullam placerat est ut metus congue sollicitudin. Phasellus eu metus ac risus tincidunt ornare. Sed eleifend sapien dolor, non commodo urna bibendum id. In eu turpis et lorem convallis lobortis vitae eu lorem. Donec porta nisi ac neque condimentum lobortis. Duis feugiat lacus nec felis tincidunt varius. Aliquam et varius neque.',
      slug: this.$route.params.slug,
      swiperOptionTop: {
        // loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        speed: 800,
        breakpoints: {
          992: {
            spaceBetween: 20,
          }
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      swiperOptionThumbs: {
        direction: "horizontal",
        loopedSlides: 5,
        slidesPerView: 4,
        centeredSlides: true,
        spaceBetween: 10,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        speed: 800,
        breakpoints: {
          992: {
            direction: "vertical",
            centeredSlides: true,
            loopedSlides: 5,
            slidesPerView: 4,
            spaceBetween: 20,
          }
        },
      },
      productQuantity: 1,
      swiperProducts: {
        slidesPerView: 1.6,
        spaceBetween: 20,
        speed: 800,
        watchOverflow: true,
        clickable: true,
        autoplay: {
          delay: 5000,
        },
        breakpoints: {
          768: {
            slidesPerView: 2.6,
          },
          992: {
            slidesPerView: 4,
          }
        },
      },
      productDetails: {
        store: {},
        family: {},
        subfamily: {},
        photos: [],
      },
      uuid_product: this.$route.params.productId,
      highLightProducts: [],
      partner_id: [],
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    CardProduct,
    CategoryStore,
    MenuCart,
    GoToBackButton,
    SocialSharing,
    BtnFavorite,
    ModalHelp,
    ShopCart
  },
  computed: {
    ...mapGetters({
      publicities: "Publicity/publicities",
      filterStore: "Products/FilterStore/filterList",
      categories: "Products/productsFilters",
    }),
    storeName() {
      return this.productDetails?.store?.name || '';
    },
    familyName() {
      return this.productDetails?.family?.name || '';
    },
  },
  methods: {
    sendFilter(subfamily, family) {
      this.$store.dispatch("Products/FilterStore/setFilterList", {
        subfamily: subfamily,
      });
      this.$router
        .push({
          name: "CategoriesStore",
          params: {
            slug: this.slug,
            family: family,
          },
        })
        .catch(() => { });
    },
    addProduct() {
      this.productDetails.quantity = this.productQuantity;
      this.$store.dispatch("Cart/setCart", { product: this.productDetails, access_token: this.access_token });
    },
    btnMinus() {
      if (this.productQuantity != 0) {
        this.productQuantity--;
      }
    },
    btnPlus() {
      this.productQuantity++;
    },
    fetchProduct() {
      axios.get('/api/v1/ecommerce/product/' + this.$route.params.product)
        .then(response => {
          this.productDetails = response.data;
          console.log('productDetails', this.productDetails);
          this.title = this.productDetails.name;
          this.partner_id = this.productDetails.store.partner_id;
          this.getHighLightProducts();
          this.$store.dispatch('Products/getFamilies', { partner_id: this.partner_id });
          this.$store.dispatch("Products/getProductsFilters", { slug: this.slug });
        })
        .catch(error => {
          console.log(error);
        });
    },
    getHighLightProducts() {
      axios.post('/api/v1/ecommerce/producthighlighted', {
        uuid: this.uuid_product
      })
        .then(response => {
          this.highLightProducts = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.swiperTop && this.$refs.swiperTop.$swiper && this.$refs.swiperThumbs && this.$refs.swiperThumbs.$swiper) {
        const swiperTop = this.$refs.swiperTop.$swiper;
        const swiperThumbs = this.$refs.swiperThumbs.$swiper;
        swiperTop.controller.control = swiperThumbs;
        swiperThumbs.controller.control = swiperTop;
      }
    });
    this.$store.dispatch('Publicity/getPublicities', this.$route.name);
    this.$store.dispatch('Products/FilterStore/setFilterList', { slug: this.slug });

    this.fetchProduct();

    this.access_token = localStorage.getItem("token") || localStorage.getItem("visitor_token") || null;

    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.content-product-intern {
  padding: 40px 0px 70px 0px;
  margin-top: 200px;

  @media (max-width: 991px) {
    margin-top: 240px;
  }

  &-itens {
    .content-brand {
      @media (max-width: 991px) {
        justify-content: space-between;
      }
    }

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      margin: 60px 0px;

      @media (max-width: 991px) {
        margin: 40px 0px;
      }

      .title {
        font-size: 25px;
        font-family: "Font Regular";
        color: var(--green-dark);
        text-align: left;
        margin-bottom: 0;

        @media (max-width: 991px) {
          font-size: 20px;
        }

        span {
          display: block;
          font-size: 35px;
          font-family: "Font Bold";
          color: var(--green-medium);

          @media (max-width: 991px) {
            font-size: 24px;
          }
        }
      }

      &-sociais {
        gap: 30px;
      }
    }

    .content-product {
      &-gallery {
        position: relative;

        .gallery-top {
          &-image {
            position: relative;
            width: calc(100% - 100px);
            height: 460px;
            background-repeat: no-repeat !important;
            background-position: center !important;
            background-size: contain !important;
            border: 1px solid #e7e7e7;
            border-radius: 10px;

            @media (max-width: 991px) {
              width: 100%;
              height: 355px;
            }

            &-discount {
              position: absolute;
              top: 20px;
              right: 20px;
              width: 138px;
              height: 73px;
              display: flex;
              justify-content: center;
              align-items: center;
              background: #e69c5a;
              border-radius: 10px;
              font-size: 29px;
              font-family: "Font Bold";
              color: var(--white);
              transition: 500ms;

              @media (max-width: 991px) {
                top: 15px;
                right: 15px;
                width: 106px;
                height: 56px;
                font-size: 26px;
              }

              &:hover,
              &:focus {
                opacity: 0.8;
              }
            }
          }
        }

        .gallery-thumbs {
          margin-top: 15px;

          @media (min-width: 992px) {
            height: 460px;
            position: absolute;
            top: 0;
            right: 0;
            padding: 80px 0px;
            margin-top: 0;
          }

          .swiper-wrapper {
            @media (max-width: 991px) {
              margin-left: -38%;
            }

            @media (min-width: 992px) {
              margin-top: -120px;
            }
          }

          .swiper-slide {
            cursor: pointer;

            .gallery-thumbs-image {
              width: 60px;
              height: 60px;
              background-repeat: no-repeat !important;
              background-position: center !important;
              background-size: cover !important;
              border: 1px solid #e7e7e7;
              border-radius: 5px;
              transition: 500ms;

              @media (max-width: 991px) {
                width: 100%;
                background-size: contain !important;
              }
            }
          }

          .swiper-slide-active {
            .gallery-thumbs-image {
              border-color: var(--green-medium);
            }
          }

          &-image {
            position: relative;
            display: inline-block;
          }
        }
      }

      &-details {
        position: relative;
        text-align: left;
        padding-top: 50px;

        @media (max-width: 991px) {
          padding-top: 30px;
        }

        &-type {
          width: calc(100% - 110px);

          h3 {
            font-size: 28px;
            font-family: 'Font Bold';
            color: var(--green-medium);
            margin-bottom: 15px;

            @media (max-width: 991px) {
              font-size: 18px;
            }
          }
        }

        &-name {
          margin-bottom: 90px;

          @media (max-width: 991px) {
            margin-bottom: 25px;
          }

          h2 {
            font-size: 40px;
            font-family: 'Font Regular';
            color: var(--green-dark);
            margin-bottom: 0;

            @media (max-width: 991px) {
              font-size: 28px;
            }
          }
        }

        &-price {
          margin-bottom: 30px;

          @media (max-width: 991px) {
            margin-bottom: 0;
          }

          .price-discount {
            p {
              font-size: 28px;
              font-family: 'Font Regular';
              color: #878787;
              text-decoration: line-through;
              line-height: 1;
              margin-bottom: 0;
            }
          }

          .price-current {
            p {
              font-size: 45px;
              font-family: 'Font Bold';
              color: var(--green-medium);
              line-height: 1;
              margin-bottom: 0;
            }
          }
        }

        &-help {
          @media (max-width: 991px) {
            display: flex;
            align-items: center;
            gap: 25px;
            margin-bottom: 30px;
          }

          @media (min-width: 992px) {
            position: absolute;
            right: 0;
            top: 50px;
          }

          .btn-help {
            width: 110px;
            height: 45px;
            display: flex;
            justify-content: center;
            align-items: center;
            background: var(--green-medium);
            border: 1px solid var(--green-medium);
            border-radius: 10px;
            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
            font-size: 18px;
            font-family: 'Font Regular';
            color: var(--white);
            transition: 500ms;

            &:hover {
              cursor: pointer;
              background: var(--white);
              color: var(--green-medium);
            }
          }
        }

        &-btns {
          display: flex;
          align-items: center;

          @media (max-width: 991px) {
            position: fixed;
            bottom: 30px;
            left: 0;
            justify-content: center;
            width: 100%;
            padding: 0px 15px;
            z-index: 3;
          }

          .number {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 170px;
            height: 60px;
            background: var(--white);
            border: 1px solid #D8D8D8;
            border-radius: 10px;
            margin-right: 25px;
            padding: 0px 22px;

            @media (max-width: 991px) {
              width: 50%;
              max-width: 170px;
              padding: 0px 15px;
              box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
              margin-right: 10px;
            }

            .minus,
            .plus {
              border: 0;
              background: 0;
              padding: 0;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            input {
              height: 100%;
              width: 50px;
              text-align: center;
              font-size: 34px;
              font-family: "Font Regular";
              color: var(--green-dark);
              background: var(--white);
              border: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              padding: 0;
              margin: 0px 10px;
              outline: none;
              pointer-events: none;

              @media (max-width: 991px) {
                width: 30px;
              }
            }
          }

          .btn-add-product {
            width: 266px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: var(--green-medium);
            border: 1px solid var(--green-medium);
            border-radius: 10px;
            transition: 500ms;

            &:hover,
            &:focus {
              background: var(--white);

              svg {
                fill: var(--green-medium);
              }

              p {
                color: var(--green-medium);
              }
            }

            svg {
              fill: var(--white);
              transition: 500ms;
            }

            p {
              font-size: 22px;
              font-family: 'Font Regular';
              color: var(--white);
              margin-right: 11px;
              margin-bottom: 0;
              transition: 500ms;
            }

            @media (max-width: 991px) {
              max-width: 266px;
              width: 50%;
              box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
            }
          }
        }
      }

      &-description {
        text-align: left;
        margin-top: 75px;
        margin-bottom: 70px;

        @media (max-width: 991px) {
          margin-top: 50px;
          margin-bottom: 70px;
        }

        &-header {
          margin-bottom: 10px;

          @media (max-width: 991px) {
            margin-bottom: 15px;
          }

          h2 {
            font-size: 28px;
            font-family: 'Font Bold';
            color: var(--green-medium);
            margin-bottom: 0px;
          }
        }

        &-text {
          @media (max-width: 991px) {
            margin-bottom: 30px;
          }

          p {
            font-size: 24px;
            font-family: 'Font Regular';
            color: var(--green-dark);
            margin-bottom: 0;
          }
        }

        .content-ads {
          padding: 30px;
          background: #F2F2F2;
          border-radius: 10px;
        }
      }

      &-features {
        text-align: left;
        margin-bottom: 140px;

        @media (max-width: 991px) {
          margin-top: 50px;
          margin-bottom: 50px;
        }

        &-header {
          margin-bottom: 10px;

          @media (max-width: 991px) {
            margin-bottom: 15px;
          }

          h2 {
            font-size: 28px;
            font-family: 'Font Bold';
            color: var(--green-medium);
            margin-bottom: 0px;
          }
        }

        &-text {
          @media (max-width: 991px) {
            margin-bottom: 30px;
          }

          p {
            font-size: 24px;
            font-family: 'Font Regular';
            color: var(--green-dark);
            margin-bottom: 0;
          }
        }
      }

      &-sugestions {
        text-align: left;

        &-header {
          margin-bottom: 30px;

          h2 {
            font-size: 25px;
            font-family: 'Font Regular';
            color: var(--green-dark);
            margin-bottom: 0px;

            span {
              display: block;
              font-size: 35px;
              font-family: 'Font Bold';
              color: var(--green-medium);
            }
          }
        }
      }
    }
  }
}

.gallery-thumbs-product-intern {

  .swiper-button-prev,
  .swiper-button-next {
    width: 60px;
    height: 60px;
    background: var(--green-medium);
    border-radius: 5px;
    top: initial;
    margin-top: initial;
    left: 0;
    right: initial;

    &::after {
      content: none;
    }

    &.swiper-button-disabled {
      background: #D8D8D8;
      opacity: 1;
    }
  }

  .swiper-button-prev {
    top: 0;

    svg {
      transform: rotate(180deg);
    }
  }

  .swiper-button-next {
    bottom: 0;
  }
}
</style>
